import { render, staticRenderFns } from "./RecentGroup.vue?vue&type=template&id=0ad35829&"
import script from "./RecentGroup.vue?vue&type=script&lang=js&"
export * from "./RecentGroup.vue?vue&type=script&lang=js&"
import style0 from "./RecentGroup.vue?vue&type=style&index=0&id=0ad35829&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports